<template>
  <div>
    <Navigation />
    <div class="row tableUsers">
      <div v-if="addNewProvider" class="popUp-overlay"></div>
      <div v-show="addNewProvider" class="popUp-dialogScrollable zHelper">
        <!-- chaged class to popUp-dialog  and added cancel button-->
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="selected_type"
                      >Type
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      >
                    </label>
                    <select
                      v-model="selected_type"
                      name="selected_type"
                      v-bind:class="
                        errorMsg && !selected_type
                          ? 'border-red'
                          : 'border-none'
                      "
                      required
                      class="custom-select custom-select-sm form-control form-control-sm"
                    >
                      <option
                        v-for="(item, index) in types"
                        v-bind:value="item.id"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="is_active"
                      >Status
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label
                    >
                    <select
                      v-model="is_active"
                      v-bind:class="
                        errorMsg && !is_active ? 'border-red' : 'border-none'
                      "
                      name="is_active"
                      required
                      class="custom-select custom-select-sm form-control form-control-sm"
                    >
                      <option
                        v-for="(item, index) in statuses"
                        v-bind:value="item.id"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="selected_type"
                      >Voucher scan code
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label
                    >
                    <select
                      v-model="scanner_type"
                      v-bind:class="
                        errorMsg && !scanner_type ? 'border-red' : 'border-none'
                      "
                      name="scanner_type"
                      required
                      class="custom-select custom-select-sm form-control form-control-sm"
                    >
                      <option
                        v-for="(item, index) in codes"
                        v-bind:value="item.id"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="floatCategories"
                      >Categories
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label
                    >
                    <v-select
                      v-if="categoryHierarchy && categoryHierarchy.length > 0"
                      v-model="selectedCategories"
                      :options="flattenCategories(categoryHierarchy)"
                      item-text="name_mkk"
                      label="name_mk"
                      multiple
                    >
                    </v-select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name_mk"
                      >Name MK
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label
                    >
                    <input
                      id="name_mk"
                      v-model="name_mk"
                      v-bind:class="
                        errorMsg && !name_mk ? 'border-red' : 'border-none'
                      "
                      type="text"
                      name="name_mk"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="description_mk"
                      >Description MK
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label
                    >
                    <textarea
                      id="description_mk"
                      v-model="description_mk"
                      v-bind:class="
                        errorMsg && !description_mk
                          ? 'border-red'
                          : 'border-none'
                      "
                      type="text"
                      name="description_mk"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name_al"
                      >Name AL
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label
                    >
                    <input
                      id="name_al"
                      v-model="name_al"
                      v-bind:class="
                        errorMsg && !name_al ? 'border-red' : 'border-none'
                      "
                      type="text"
                      name="name_al"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="description_al"
                      >Description AL
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label
                    >
                    <textarea
                      id="description_al"
                      v-model="description_al"
                      v-bind:class="
                        errorMsg && !description_al
                          ? 'border-red'
                          : 'border-none'
                      "
                      type="text"
                      name="description_al"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name_en"
                      >Name EN
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label
                    >
                    <input
                      id="name_en"
                      v-model="name_en"
                      v-bind:class="
                        errorMsg && !name_en ? 'border-red' : 'border-none'
                      "
                      type="text"
                      name="name_en"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="description_en"
                      >Description EN
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      >
                    </label>
                    <textarea
                      id="description_en"
                      v-model="description_en"
                      v-bind:class="
                        errorMsg && !description_en
                          ? 'border-red'
                          : 'border-none'
                      "
                      type="text"
                      name="description_en"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div v-if="errorMsg" class="row">
                <div class="col-md-12">
                  <div class="error-infobox">
                    {{ errorMsg }}
                  </div>
                </div>
              </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    @click.prevent="addProvider()"
                    type="submit"
                    class="btn btnDark btn-success btn-send pointer"
                    value="Submit"
                  />
                  <input
                    v-on:click="
                      addNewProvider = false;
                      clearForm();
                      errorMsg = '';
                    "
                    type="cancel"
                    class="btn btn-secondary pointer button-width-helper"
                    value="Cancel"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-if="editProvider" class="popUp-overlay"></div>
      <div v-show="editProvider" class="popUp-dialogScrollable zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="selected_type">Type</label>
                    <select
                      v-model="selected_type"
                      name="selected_type"
                      required
                      class="custom-select custom-select-sm form-control form-control-sm"
                    >
                      <option
                        v-for="(item, index) in types"
                        v-bind:value="item.id"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="is_active">Status</label>
                    <select
                      v-model="is_active"
                      name="is_active"
                      required
                      class="custom-select custom-select-sm form-control form-control-sm"
                    >
                      <option
                        v-for="(item, index) in statuses"
                        v-bind:value="item.id"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="scanner_type"
                      >Voucher scan code</label
                    >
                    <select
                      v-model="scanner_type"
                      name="scanner_type"
                      required
                      class="custom-select custom-select-sm form-control form-control-sm"
                    >
                      <option
                        v-for="(item, index) in codes"
                        v-bind:value="item.id"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatCategories">Categories</label>
                    <v-select
                      v-if="categoryHierarchy && categoryHierarchy.length > 0"
                      v-model="selectedCategories"
                      :options="flattenCategories(categoryHierarchy)"
                      item-text="name_mk"
                      item-value="id"
                      v-bind:class="{
                        'custom-border-red':
                          errorMsg && selectedCategories.length < 1,
                      }"
                      label="name_mk"
                      id="selectCategories"
                      multiple
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name_mk">Name MK</label>
                    <input
                      id="name_mk"
                      v-model="name_mk"
                      v-bind:class="
                        errorMsg && !name_mk ? 'border-red' : 'border-none'
                      "
                      type="text"
                      name="name_mk"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />

                    <input type="hidden" v-model="provider_id" value />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="description_mk"
                      >Description MK
                    </label>
                    <textarea
                      id="description_mk"
                      v-model="description_mk"
                      v-bind:class="
                        errorMsg && !description_mk
                          ? 'border-red'
                          : 'border-none'
                      "
                      type="text"
                      name="description_mk"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name_al">Name AL</label>
                    <input
                      id="name_al"
                      v-model="name_al"
                      v-bind:class="
                        errorMsg && !name_al ? 'border-red' : 'border-none'
                      "
                      type="text"
                      name="name_al"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="description_al"
                      >Description AL
                    </label>
                    <textarea
                      id="description_al"
                      v-model="description_al"
                      v-bind:class="
                        errorMsg && !description_al
                          ? 'border-red'
                          : 'border-none'
                      "
                      type="text"
                      name="description_al"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name_en">Name EN</label>
                    <input
                      id="name_en"
                      v-model="name_en"
                      v-bind:class="
                        errorMsg && !name_en ? 'border-red' : 'border-none'
                      "
                      type="text"
                      name="name_en"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="description_en"
                      >Description EN
                    </label>
                    <textarea
                      id="description_en"
                      v-model="description_en"
                      v-bind:class="
                        errorMsg && !description_en
                          ? 'border-red'
                          : 'border-none'
                      "
                      type="text"
                      name="description_en"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>

              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    @click.prevent="updateProvider()"
                    type="submit"
                    class="btn btnDark btn-success btn-send pointer"
                    value="Save"
                  />
                  <input
                    v-on:click="
                      editProvider = false;
                      clearForm();
                      errorMsg = '';
                    "
                    type="cancel"
                    class="btn btn-secondary pointer button-width-helper"
                    value="Cancel"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!--new part-->
      <div v-if="showLocations1" class="popUp-overlay"></div>
      <div
        v-show="showLocations1"
        class="popUp-dialogScrollable zHelper"
        style="max-width: 1000px"
      >
        <div class="col-md-12">
          <!-- table with locations-->
          <button
            @click="cancelAction"
            class="btn btn-secondary pointer floatRight1"
          >
            <v-icon class="cancel-icon">mdi-close</v-icon>
          </button>
          <h3>Локации за {{ this.$data.nameData }}</h3>
          <div>
            <table
              class="table table-striped table-bordered dataTable dtr-inline"
              cellspacing="0"
              width="100%"
              role="grid"
            >
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Code</th>
                  <th>is active</th>
                </tr>
              </thead>
              <tbody>
                <!-- Table rows for existing locations -->
                <tr
                  v-for="(location, index) of locations"
                  :key="index"
                  :class="{ 'highlighted-row': location.editing }"
                >
                  <td>
                    <input
                      type="text"
                      v-model="location.provider_location_name"
                      v-bind:class="{
                        'border-red':
                          errorMsg1 &&
                          location.provider_location_name.length === 0,
                        'border-none':
                          !errorMsg1 || location.provider_location_name !== '',
                      }"
                      :disabled="!location.editing"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      @input="validateInput(location)"
                      v-model="location.provider_location_code"
                      v-bind:class="{
                        'border-red':
                          errorMsg1 &&
                          location.provider_location_code.length === 0,
                        'border-none':
                          !errorMsg1 || location.provider_location_code !== '',
                      }"
                      :disabled="!location.editing"
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      v-model="location.isActive"
                      :disabled="!location.editing"
                    />
                  </td>
                  <td>
                    <button
                      v-if="location.editing"
                      @click="saveLocation(location)"
                      class="btn btn-success pointer"
                      style="background-color: rgb(18, 112, 92) !important;"
                    >
                      <v-icon style="color:white"
                        >mdi-map-marker-plus-outline</v-icon
                      >
                    </button>
                    <button
                      v-else
                      @click="editLocation(location)"
                      class="btn btn-secondary pointer"
                    >
                      <v-icon style="color:white"
                        >mdi-circle-edit-outline</v-icon
                      >
                    </button>
                  </td>
                </tr>
                <!-- Table row for adding new location -->
                <tr class="input-newlocation">
                  <td>
                    <input
                      v-model="newLocation.provider_location_name"
                      v-bind:class="{
                        'border-red':
                          errorMsg &&
                          newLocation.provider_location_name.length === 0,
                        'border-none':
                          !errorMsg ||
                          newLocation.provider_location_name !== '',
                      }"
                      placeholder="Name"
                    />
                  </td>
                  <td>
                    <input
                      v-model="newLocation.provider_location_code"
                      v-bind:class="{
                        'border-red':
                          errorMsg &&
                          newLocation.provider_location_code.length === 0,
                        'border-none':
                          !errorMsg ||
                          newLocation.provider_location_code !== '',
                      }"
                      type="text"
                      placeholder="code"
                      @input="validateInput"
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      v-model="newLocation.isActive"
                      placeholder="is active"
                    />
                  </td>
                  <td>
                    <button class="btn btn-dark" @click="addLocation">
                      <v-icon style="color:white">mdi-plus-circle</v-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- end new part-->

      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="toolbar">
              <!-- Here you can write extra buttons/actions for the toolbar -->
            </div>
            <div
              id="datatable_wrapper"
              class="dataTables_wrapper dt-bootstrap4"
            >
              <div class="row">
                <div class="col-sm-12 col-md-4 tableName tableHeading">
                  <a
                    href="#"
                    class="btn btn-round btn-icon btn-sm createNew mt-1"
                    title="Add new provider"
                    v-on:click="addNew()"
                  >
                    <i class="fas fa-plus"></i>
                  </a>
                  Providers
                </div>
                <div class="col-sm-12 col-md-5">
                  <!-- Filter by type -->
                </div>

                <!-- Filter by Provider -->

                <div class="col-sm-12 col-md-3">
                  <div id="datatable_filter" class="dataTables_filter">
                    <form
                      class="form-inline md-form floatRight searchDiv form-sm active-darkGreen-2 mt-3"
                    >
                      <input
                        v-model="searchProvider"
                        name="query"
                        v-on:keyup="filterProviderResults()"
                        class="form-control borderNone form-control-sm mr-3"
                        type="text"
                        placeholder="Search"
                        aria-label="Search"
                      />
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </form>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 min-table-height">
                  <table
                    id="datatable"
                    class="table table-striped table-bordered dataTable dtr-inline"
                    cellspacing="0"
                    width="100%"
                    role="grid"
                    aria-describedby="datatable_info"
                    style="width: 100%"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          class="sorting_asc"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-sort="ascending"
                          aria-label="Name: activate to sort column descending"
                          v-on:click="sortProviderResults(1)"
                        >
                          Provider name
                        </th>
                        <th
                          class="disabled-sorting sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 230px"
                          aria-label="Actions: activate to sort column ascending"
                          v-on:click="sortProviderResults(2)"
                        >
                          Provider description
                        </th>
                        <th
                          class="disabled-sorting sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 230px"
                          aria-label="Actions: activate to sort column ascending"
                        >
                          Is Active
                        </th>
                        <!--         <th
                          class="disabled-sorting sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 230px"
                          aria-label="Actions: activate to sort column ascending"
                          v-on:click="sortProviderResults(3)"
                        >
                          Number of vouchers types
                        </th> -->
                        <!--          <th
                          class="disabled-sorting sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 230px"
                          aria-label="Actions: activate to sort column ascending"
                          v-on:click="sortProviderResults(4)"
                        >
                          Number of vouchers
                        </th> -->
                        <th
                          class="sorting_asc"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-sort="ascending"
                          aria-label="Name: activate to sort column descending"
                          v-on:click="sortProviderResults(3)"
                        >
                          Provider type
                        </th>
                        <th
                          class="disabled-sorting text-right sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 230px"
                          aria-label="Actions: activate to sort column ascending"
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        role="row"
                        v-bind:key="index"
                        v-for="(provider, index) in provider_voucher_stats"
                        v-bind:class="[
                          index % 2 == 0 || index == 0 ? 'even' : 'odd',
                        ]"
                      >
                        <td tabindex="0" class="sorting_1">
                          {{ provider.nameMk }}
                        </td>
                        <td tabindex="0" class="sorting_1">
                          {{ provider.descriptionMk }}
                        </td>
                        <td tabindex="0" class="sorting_1">
                          {{ provider.isActive ? 1 : 0 }}
                        </td>
                        <!--   <td tabindex="0" class="sorting_1">
                          {{ provider.number_vt }}
                        </td> -->
                        <!--   <td tabindex="0" class="sorting_1">
                          {{ provider.number_vouchers }}
                        </td> -->
                        <td>
                          <span v-if="provider.provider_type == 1"
                            >Продукт</span
                          >
                          <span v-else-if="provider.provider_type == 2">
                            Донација</span
                          >
                        </td>
                        <td class="text-right" style="width: 13%;">
                          <div class="actions_on_user">
                            <a
                              href="#"
                              class="btn btn-round btn-edit btn-icon btn-sm edit"
                              @click.prevent="edit(provider.id)"
                              id="edit"
                            >
                              <i class="far fa-edit"></i>
                            </a>
                            <label class="activity_label" for="edit"
                              >Edit</label
                            >
                          </div>
                          <div class="actions_on_user">
                            <a
                              href="#"
                              class="btn btn-round btn-edit btn-icon btn-sm edit"
                              @click.prevent="
                                showLocations(provider.id, provider.nameMk)
                              "
                              id="locations"
                            >
                              <i class="far fa-eye"></i>
                            </a>
                            <label class="activity_label" for="locations"
                              >Locations</label
                            >
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <pagination
                :meta_data="meta_data_provider"
                v-on:next="fetchProviderResults"
              ></pagination>
            </div>
          </div>
          <!-- end content-->
        </div>
        <!--  end card  -->
      </div>
      <!-- end col-md-12 -->
    </div>
  </div>
</template>
<script>
import Navigation from "@/views/Navigation.vue";
import axios from "axios";
import Pagination from "@/components/Pagination.vue";
import store from "./../store/index";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    Navigation,
    Pagination,
    vSelect,
  },
  data() {
    return {
      selectedItems: [],

      extension_url: "",
      addNewProvider: false,
      provider_voucher_stats: null,
      searchProvider: null,
      orderProvider: null,
      sortProvider: null,
      dirProvider: null,
      name_mk: null,
      description_mk: null,
      name_al: null,
      description_al: null,
      name_en: null,
      description_en: null,
      editProvider: false,
      showLocations1: false,
      editing: false,
      idData: null,
      nameData: null,
      locations: [],
      newLocation: {
        provider_location_name: "",
        provider_location_code: "",
        isActive: false,
      },
      selected_type: null,
      provider_id: null,
      is_active: false,
      scanner_type: null,
      categoryId: null,
      statuses: [
        {
          id: 1,
          text: "Active",
        },
        {
          id: 0,
          text: "Non-active",
        },
      ],
      codes: [
        {
          id: 1,
          text: "QR Code",
        },
        {
          id: 0,
          text: "Bar Code",
        },
      ],
      meta_data_provider: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        perpage: 5,
        total: 0,
      },
      types: [
        {
          id: 1,
          text: "Продукт",
        },
        {
          id: 2,
          text: "Донација",
        },
      ],
      isOpen: false,
      categories: [],
      selectedCategory: null,
      selectedCategoriesId: null,
      selectedCategories: [],
      previousSelectedCategories: [],
      selectedCategoriesNames: [],
      catMessage: null,
      errorMsg: "",
      errorMsg1: "",
      categoryHierarchy: [],
      categoryFetch: [],
      changedCategoryNames: [],
    };
  },
  mounted() {
    this.setURL();
    this.fetchProviderResults(
      this.meta_data_provider.current_page,
      this.meta_data_provider.perpage,
      this.searchProvider,
      this.orderProvider,
      this.sortProvider
    );
    this.fetchCategories().then(() => {
      //console.log(" ", this.flattenCategories(this.categoryHierarchy)); // Check structure
    });
    document.addEventListener("keydown", this.onEscapeKey);
  },
  computed: {
    filteredCategories() {
      if (!this.selectedCategories || this.selectedCategories.length === 0) {
        return this.categories;
      }
      return this.categories.filter(
        (category) => !this.selectedCategories.includes(category)
      );
    },
  },
  destroyed() {
    document.removeEventListener("keydown", this.onEscapeKey);
  },
  methods: {
    setURL() {
      if (store.state.ENV === "dev") {
        this.extension_url = store.state.EXTENSION_DEV_URL;
      } else if (store.state.ENV === "test") {
        this.extension_url = store.state.EXTENSION_TEST_URL;
      } else {
        this.extension_url = store.state.EXTENSION_PROD_URL;
      }
    },
    onEscapeKey(event) {
      if (event.key === "Escape" && this.addNewProvider) {
        this.clearFormProvider();
      }
      if (event.key === "Escape" && this.showLocations1) {
        this.cancelAction();
      }
      if (event.key === "Escape" && this.editProvider) {
        this.clearForm();
        this.editProvider = false;
      }
    },

    //for selecting categories
    // async fetchCategories() {
    //   try {
    //     const response = await axios.get(
    //       `${this.extension_url}api/Category/GetAllCategoriesInProviders`,
    //       {
    //         headers: { Authorization: localStorage.getItem("accessToken") },
    //       }
    //     );

    //     this.categories = response.data;
    //     response.data.forEach((item) => {
    //       this.selectedCategoriesNames.push(item.name_mk);
    //     });
    //   } catch (error) {
    //     console.error("Error fetching categories:", error);
    //   }
    // },
    async fetchCategories() {
      try {
        const response = await axios.get(
          `${this.extension_url}api/Category/GetAllCategoriesInProviders`,
          {
            headers: { Authorization: localStorage.getItem("accessToken") },
          }
        );

        const categories = response.data;
        this.categoryFetch = response.data;
        this.categoryHierarchy = this.buildCategoryHierarchy(categories);
        //console.log(this.categoryHierarchy);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },

    buildCategoryHierarchy(categories) {
      const categoryMap = {};
      const categoryHierarchy = [];

      // map of categories by their ID
      categories.forEach((category) => {
        categoryMap[category.id] = { ...category, children: [] };
      });

      categories.forEach((category) => {
        if (category.parentId) {
          // If it has a parent
          const parentCategory = categoryMap[category.parentId];
          if (parentCategory) {
            parentCategory.children.push(categoryMap[category.id]);
          }
        } else {
          categoryHierarchy.push(categoryMap[category.id]);
        }
      });
      return categoryHierarchy;
    },
    flattenCategories(categories) {
      let flatList = [];

      categories.forEach((category) => {
        flatList.push({
          id: category.id,
          label: category.name_mk,
          isParent: category.children && category.children.length > 0,
          children: category.children || [],
          name_mk: category.name_mk,
        });

        //console.log("flatList", flatList);

        if (category.children) {
          const childCategories = this.flattenCategories(category.children);
          flatList = flatList.concat(
            childCategories.map((child) => ({
              ...child,
              name_mk: `--  ${category.name_mk} -- ${child.label}`,
            }))
          );
        }
      });
      this.changedCategoryNames = flatList;
      return flatList;
      // ako flatlist.map((item)=>{ item.label == parking push to categoriList,ako item.label == --parking pusht to sub category})
    },

    validateInput(location) {
      if (this.newLocation.provider_location_code.trim()) {
        this.newLocation.provider_location_code = this.newLocation.provider_location_code.replace(
          /[^0-9]/g,
          ""
        );

        if (this.newLocation.provider_location_code.length > 6) {
          this.newLocation.provider_location_code = this.newLocation.provider_location_code.slice(
            0,
            6
          );
        }
      } else {
        location.provider_location_code = location.provider_location_code.replace(
          /[^0-9]/g,
          ""
        );
        if (location.provider_location_code.length > 6) {
          location.provider_location_code = location.provider_location_code.slice(
            0,
            6
          );
        }
      }
    },
    async getLocations(id) {
      console.log("Extension url is:", this.extension_url);
      await axios
        .get(
          `${this.extension_url}api/ProviderLocation/GetAllLocationsByProvider?providerId=${id}`,
          {
            headers: { Authorization: localStorage.getItem("accessToken") },
            params: {
              provider_id: id,
            },
          }
        )
        .then((res) => {
          this.locations = res.data;
          this.locations.map((location) => {
            location.editing = false;
          });
        });
    },
    showLocations(id, name) {
      this.idData = id;
      this.nameData = name;
      this.$data.showLocations1 = true;
      this.getLocations(id);
    },
    editLocation(location) {
      location.editing = !location.editing;
      this.locations = JSON.parse(JSON.stringify(this.locations));
    },
    async addLocation() {
      const providerId = this.idData;
      if (
        this.newLocation.provider_location_name &&
        this.newLocation.provider_location_code
      ) {
        const postData = {
          serviceProviderId: providerId,
          provider_location_name: this.newLocation.provider_location_name,
          provider_location_code: this.newLocation.provider_location_code,
          isActive: this.newLocation.isActive,
        };
        axios.defaults.headers.common["Content-Type"] =
          "application/json;charset=utf-8";

        await axios
          .post(`${this.extension_url}api/ProviderLocation`, postData, {
            headers: {
              Authorization: localStorage.getItem("accessToken"),
            },
          })
          .then(async (response) => {
            if (response) {
              console.log("Location added successfully:", response.data);
              await this.getLocations(postData.serviceProviderId);
              this.$toasted
                .show("Локацијата е успешно додадена", { type: "success" })
                .goAway(2000);
            }
          })
          .catch((error) => {
            console.log(error.response.data);

            if (error.response.data == "This location code already exists") {
              this.$toasted
                .show("Кодот на локацијата веќе постои", { type: "error" })
                .goAway(2000);
            }
          });
      } else {
        if (this.newLocation.provider_location_name === "") {
          this.errorMsg = "Името на локацијата не може да биде празно";
          this.$toasted
            .show(this.errorMsg, {
              type: "error",
            })
            .goAway(2000);
          return;
        } else {
          this.errorMsg = "Kодот на локацијата не може да биде празeн";
          this.$toasted
            .show(this.errorMsg, {
              type: "error",
            })
            .goAway(2000);
          return;
        }
      }
      // Clear input fields
      this.newLocation.provider_location_name = "";
      this.newLocation.provider_location_code = "";
      this.newLocation.isActive = false;
      this.errorMsg = "";
    },
    async saveLocation(location) {
      try {
        const previous_codes = await axios.get(
          `${this.extension_url}api/ProviderLocation`,
          {
            headers: { Authorization: localStorage.getItem("accessToken") },
          }
        );
        var previous = [],
          prevnames = [];
        previous_codes.data.forEach((name) => {
          prevnames.push(name.provider_location_name);
        });
        previous_codes.data.forEach((code) => {
          previous.push(code.provider_location_code);
        });
        //get current location from db
        const currLocation = await axios.get(
          `${this.extension_url}api/ProviderLocation/${location.id}`,
          {
            headers: { Authorization: localStorage.getItem("accessToken") },
          }
        );

        if (
          previous.includes(location.provider_location_code) &&
          currLocation.data.provider_location_code !=
            location.provider_location_code
        ) {
          // check!
          this.$toasted
            .show("Кодот на локацијата веќе постои", { type: "error" })
            .goAway(2000);
          return;
        }
        if (
          prevnames.includes(location.provider_location_name) &&
          currLocation.data.provider_location_name !=
            location.provider_location_name
        ) {
          // check!
          this.$toasted
            .show("Името на локацијата веќе постои", { type: "error" })
            .goAway(2000);
          return;
        }
        if (!location.provider_location_code.trim()) {
          this.errorMsg1 = "Кодот на локацијата не може да биде празен";
          this.$toasted
            .show(this.errorMsg1, {
              type: "error",
            })
            .goAway(2000);
          return;
        }
        if (!location.provider_location_name.trim()) {
          this.errorMsg1 = "Името на локацијата не може да биде празно";
          this.$toasted
            .show(this.errorMsg1, {
              type: "error",
            })
            .goAway(2000);
          return;
        }
        location.editing = false;
        const response = await axios.put(
          `${this.extension_url}api/ProviderLocation/${location.id}`,
          {
            serviceProviderId: location.serviceProviderId,
            provider_location_name: location.provider_location_name,
            provider_location_code: location.provider_location_code,
            isActive: location.isActive,
          },
          {
            headers: {
              Authorization: localStorage.getItem("accessToken"),
            },
          }
        );
        if (response && response.data) {
          console.log("Location saved", response.data);
          delete location.editing; // Remove editing flag
          this.$toasted
            .show("Локацијата е успешно зачувана.", {
              type: "success",
            })
            .goAway(2000);
        }
      } catch (error) {
        if (error.response.data == "This location code already exists") {
          this.$toasted
            .show("Кодот на локацијата веќе постои", { type: "error" })
            .goAway(2000);
        }
        if (error.response.data == "Service Provider does not exist.") {
          this.$toasted
            .show("Провајдерот не постои", { type: "error" })
            .goAway(2000);
        }
        this.errorMsg1 = "Error saving location";
        console.log("Error saving location: ", error);
      }
    },
    /// end
    addNew() {
      this.selectedCategories = []; // to reset selectedCategories
      this.$data.addNewProvider = true;
      // this.fetchCategories();
      this.errorMsg = "";
    },
    edit(id) {
      this.idData = id;
      this.$data.editProvider = true;
      this.getEditingForm(id);
    },
    async getEditingForm(id) {
      await this.fetchCategories();

      await axios
        .get(`${this.extension_url}api/ServiceProvider/${id}`, {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {
            id: id,
          },
        })
        .then((res) => {
          this.name_mk = res.data.nameMk;
          this.name_en = res.data.nameEn;
          this.name_al = res.data.nameAl;
          this.description_mk = res.data.descriptionMk;
          this.description_al = res.data.descriptionAl;
          this.description_en = res.data.descriptionEn;
          this.selected_type = res.data.providerType;
          this.provider_id = res.data.id;
          this.is_active = res.data.isActive ? 1 : 0;
          this.scanner_type = res.data.scannerType;

          this.selectedCategories = res.data.categoryIds.map((categoryId) => {
            return this.changedCategoryNames.find(
              (category) => category.id === categoryId
            );
          });
          console.log(this.categoryHierarchy);
          this.previousSelectedCategories = res.data.categoryIds;
          // this.selectedCategoriesId = res.data.categoryIds;
          //this.previousSelectedCategories = this.selectedCategoriesId;
        })
        .catch((error) => {
          console.error("Error fetching provider data:", error);
        });
    },
    //  FOR Providers --->>>
    // sort
    sortProviderResults(order) {
      this.dirProvider++;
      this.orderProvider = order;
      if (this.dirProvider % 2 == 0) this.sortProvider = "desc";
      else this.sortProvider = "asc";
      this.fetchProviderResults(
        this.meta_data_provider.current_page,
        this.meta_data_provider.perpage,
        this.searchProvider,
        this.orderProvider,
        this.sortProvider
      );
    },

    addProvider() {
      console.log(this.selectedCategory);
      var post_data = {
        NameMk: this.name_mk,
        NameAl: this.name_al,
        NameEn: this.name_en,
        DescriptionMk: this.description_mk,
        DescriptionAl: this.description_al,
        DescriptionEn: this.description_en,
        ProviderType: this.selected_type,
        IsActive: this.is_active,
        ScannerType: this.scanner_type,
        CategoryIds: this.selectedCategories.map((category) => category.id),
        //CategoryIds: this.selectedCategories ? this.selectedCategories.map(category => category.value).filter(id => id !== null) : []
        // CategoryIds: this.selectedCategoriesId,
        // CategoryIds: this.selectedCategories ? this.selectedCategories.map(function (category) {
        //     return category.id;
        // }) : []
      };
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "accessToken"
      );
      if (!post_data.CategoryIds.length) {
        console.log("prazna cat");
        this.errorMsg = "Please fill all the required fields";
      }
      axios
        .post(
          `${this.extension_url}api/ServiceProvider/PostServiceProvider`,
          post_data,
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          }
        )
        .then((response) => {
          this.addNewProvider = false;
          this.fetchProviderResults(
            this.meta_data_provider.current_page,
            this.meta_data_provider.perpage,
            this.searchProvider,
            this.orderProvider,
            this.sortProvider
          );
          this.$toasted
            .show("Провајдерот е успешно додаден", { type: "success" })
            .goAway(2000);
          this.clearForm();

          // this.errorMsg = "";
          this.$toasted
            .show(response.data.message, {
              type: "success",
            })
            .goAway(2000);
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = "Please fill all the required fields";
          }
          //this.errorMsg = "Please fill all the required fields";
        });
    },

    // filter
    filterProviderResults(order) {
      this.dirProvider++;
      this.orderProvider = order;

      if (this.dirProvider % 2 == 0) this.sortProvider = "desc";
      else this.sortProvider = "asc";
      this.fetchProviderResults(
        this.meta_data_provider.current_page,
        this.meta_data_provider.perpage,
        this.searchProvider,
        this.orderProvider,
        this.sortProvider
      );
    },
    searchProviderResults() {
      this.fetchProviderResults(
        this.meta_data_provider.current_page,
        this.meta_data_provider.perpage,
        this.searchProvider,
        this.orderProvider,
        this.sortProvider
      );
    },
    // fetch
    fetchProviderResults(
      page = this.meta_data_provider.current_page,
      perpage = this.meta_data_provider.perpage,
      search = this.searchProvider,
      order = this.orderProvider,
      sort = this.sortProvider,
      total = this.meta_data_provider.total
    ) {
      axios
        .get(
          `${this.extension_url}api/ServiceProvider/GetAllServiceProviders`,
          {
            headers: { Authorization: localStorage.getItem("accessToken") },
            params: {
              page,
              perpage,
              search,
              order,
              sort,
              total,
            },
          }
        )
        .then((res) => {
          this.provider_voucher_stats = res.data.data; //.results.provider_stats;
          var pagination = res.data.pagination;
          this.meta_data_provider.last_page = pagination.last_page;
          this.meta_data_provider.current_page = pagination.current_page;
          this.meta_data_provider.prev_page_url = pagination.prev_page_url;
          this.meta_data_provider.perpage = pagination.perpage;
          this.meta_data_provider.search = pagination.search;
          this.meta_data_provider.total = pagination.total;
        });
    },

    updateProvider() {
      // after showing the form for edit, update the form
      var post_data = {
        id: this.provider_id,
        NameMk: this.name_mk,
        NameAl: this.name_al,
        NameEn: this.name_en,
        DescriptionMk: this.description_mk,
        DescriptionAl: this.description_al,
        DescriptionEn: this.description_en,
        ProviderType: this.selected_type,
        IsActive: this.is_active,
        ScannerType: this.scanner_type,
        CategoryIds: this.selectedCategories
          ? this.selectedCategories.map((category) => category.id)
          : [],
      };
      this.selectedCategoriesId = post_data.CategoryIds;
      const categoryIds = this.selectedCategories
        ? this.selectedCategories.map((category) => category.id)
        : [];

      if (
        post_data.CategoryIds.length < 1 ||
        !post_data.NameMk.trim() ||
        !post_data.NameAl.trim() ||
        !post_data.NameEn.trim() ||
        !post_data.DescriptionMk.trim() ||
        !post_data.DescriptionAl.trim() ||
        !post_data.DescriptionEn.trim()
      ) {
        this.errorMsg = "Please fill all the required fields";
      } else {
        const removedCategoryIds = this.previousSelectedCategories.filter(
          (categoryId) => !this.selectedCategoriesId.includes(categoryId)
        );

        const payload = {
          categoryIds: categoryIds,
        };

        if (removedCategoryIds.length > 0) {
          axios.delete(
            `${this.extension_url}api/ServiceProvider/${this.provider_id}/categories`,
            {
              data: payload.categoryIds,
            }
          );
        }

        axios.defaults.headers.common["Authorization"] = localStorage.getItem(
          "accessToken"
        );
        axios
          .put(
            `${this.extension_url}api/ServiceProvider/${this.provider_id}`,
            post_data,
            {
              headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }
          )
          .then((response) => {
            this.editProvider = false;

            this.clearForm();
            this.fetchProviderResults(
              this.meta_data_provider.current_page,
              this.meta_data_provider.perpage,
              this.searchProvider,
              this.orderProvider,
              this.sortProvider
            );
            this.$toasted
              .show(response.data.message, {
                type: "success",
              })
              .goAway(2000);
          })
          .catch((error) => {
            this.errorMsg = "Please fill all the required fields";
          });
      }
    },

    clearForm() {
      this.selected_type = null;
      this.name_mk = "";
      this.description_mk = "";
      this.name_al = "";
      this.description_al = "";
      this.name_en = "";
      this.description_en = "";
      this.provider_id = "";
      this.is_active = null;
      this.scanner_type = null;
      this.selectedCategoriesId = null;
      this.selectedCategories = [];
      this.catMessage = null;
      this.errorMsg = "";
      console.log("clear form");
    },

    //  FOR Voucher  --->>>
    clearFormLocations() {
      this.newLocation.provider_location_name = "";
      this.newLocation.provider_location_code = "";
      this.newLocation.isActive = false;
    },
    clearFormProvider() {
      this.addNewProvider = false;
      this.clearForm();
      this.errorMsg = "";
    },
    cancelAction() {
      this.showLocations1 = false;
      this.clearFormLocations();
      this.errorMsg = "";
    },
  },
};
</script>

<style src="../css/style.css"></style>
